import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const IFCDesignRiskReview = () => {
  const serviceData = {
    title: "IFC Design & Risk Review",
    heading: "IFC Design & Risk Review",
    image: subTopicImages["IFC Design & Risk Review"],
    intro: "Building strong internal financial control environments",
    description: [
      "Internal Financial Controls (IFC) are critical to ensuring reliable financial reporting, fraud prevention and governance integrity. Indian regulations require companies to establish and maintain effective internal controls over financial processes.",
      "We support organisations in designing, documenting, testing and strengthening IFC frameworks — ensuring controls are robust, practical and compliant.",
    ],
    services: [
      {
        title: "IFC Framework Design",
        text: "Development of structured control frameworks aligned to:",
        list: ["financial cycles", "business risk profile"],
        extraInfo:
          "Ensuring controls are tailored to the organisation’s operations.",
      },
      {
        title: "Control Testing & Documentation",
        text: "Assessment of control effectiveness through:",
        list: ["walkthroughs", "sampling", "system reviews"],
        extraInfo: "Supported by clear and structured documentation.",
      },
      {
        title: "Risk & Control Gaps Review",
        text: "Identification of weaknesses with:",
        list: ["remediation planning", "implementation support"],
        extraInfo: "To strengthen the overall control environment.",
      },
    ],
    benefitsIntro: "Benefits of this service:",
    benefits: [
      "Stronger governance foundation",
      "Reliable control environment",
      "Regulatory & audit readiness",
      "Reduced fraud & process risk",
      "Confidence for Boards & investors",
    ],
    research:
      "We combine technical control design expertise with real-world operational understanding, ensuring IFC frameworks are both compliant and practical to implement.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default IFCDesignRiskReview;
